import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { AccountService } from 'src/app/services/account.service';
import { FileUploadService } from 'src/app/services/file-upload.service';

@Component({
  selector: 'app-payProfile-upload',
  templateUrl: './payprofile-upload.component.html',
  styleUrls: ['./payprofile-upload.component.css']
})
export class PayProfileUploadComponent implements OnInit {
 
  api_error: any;
  api_success: string;
  acc_status;
  statusTo: string;
  disableConfirmbtn = false;
  changeStatus;
  fileToUpload: File = null;
  fileUploadSubscription: Subscription;
  constructor(private dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any, private accountService: AccountService,private fileuploadService: FileUploadService,) { }

  ngOnInit() {
  }
  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);

  }
  public closeDialog() {
    this.dialogRef.close();
  }
  uploadFile() {
    this.api_error = '';
    this.api_success = '';
    this.disableConfirmbtn = true;
    this.fileuploadService.postPaymentProfileFile(this.fileToUpload, this.data.id)
       .subscribe(
         res => {
          this.api_success = 'Uploaded Successfully';
          setTimeout(() => {
            this.dialogRef.close('reloadlist');
            }, 2000);
         },
         error => {
          this.disableConfirmbtn = false;
           this.api_error = error.error;
         }
       );
      
   }
  //  isValidData(file, id?) {

  //   if (file === undefined || file === null || id === 0 ) {
  //     return false;
  //   } else {
  //     return true;
  //   }

  // }
}
